<template>
  <v-card>
    <v-card-title>
      <div class="headline">
        Настройки подключения ({{ counterData.model_name }}, {{ counterData.serial_num }})
      </div>
    </v-card-title>
    <v-card-text>
      <v-select
        v-model="sourceParam.value"
        :items="sourceParams"
        label="Источник данных"
      />
      <v-text-field
        v-for="param in visibleParams"
        :key="param.param"
        v-model="param.value"
        :label="param.name"
        :rules="inputRules"
        required
      />
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn
        color="primary"
        text
        @click="setConnectParameters"
      >Сохранить</v-btn>
      <v-btn
        color="primary"
        text
        @click="$emit('cancel')"
      >Отмена</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'PointCounterEditConnectParameters',
  props: {
    counterData: {}
  },
  data () {
    return {
      inputRules: [
        v => !!v || 'Заполните это поле!'
      ],
      sourceParams: ['TCP', 'lorawandb'],
      sourceParam: {},
      dataParams: [],
      connectStatus: null
    }
  },
  computed: {
    visibleParams () {
      return this.dataParams.filter(item =>
        this.sourceParam.value === 'TCP'
          ? item.param !== 'source'
          : item.param === 'net_address'
      )
    }
  },
  mounted () {
    this.getConnectParameters()
  },
  methods: {
    getConnectParameters () {
      this.axios.get(`/api/counters/${this.counterData.counter_id}/conn_params/`)
        .then((response) => {
          this.dataParams = response.data.map(param => ({
            param: param.par_name,
            name: param.description,
            value: param.par_value,
            old_value: param.par_value
          }))
          console.log(response.data)
          this.sourceParam = this.dataParams.find(param => param.param === 'source')
          if (!this.sourceParam.value) {
            this.sourceParam.value = 'TCP'
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    setConnectParameters () {
      const connectParameters = { conn_params: this.visibleParams.filter(param => param.value !== param.old_value) }
      if (this.sourceParam.value !== this.sourceParam.old_value) {
        connectParameters.conn_params.push(this.sourceParam)
      }
      this.axios.put(`/api/point_counter/${this.counterData.counter_id}/update_conn_params/`, connectParameters)
        .then((response) => {
          this.$emit('edited')
        })
        .catch((err) => {
          this.$emit('editError', err.response.data)
        })
    },
    checkConnectParameters () {
      this.connectStatus = this.connectStatus === 'Удачно' ? 'Ошибка' : 'Удачно'
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/spa/points/counters/PointCounterEditConnectParameters.vue